export default __webpack_public_path__ + "static/media/prize-5-bm.6a8dd1c6.webp";